import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Divider from '@material-ui/core/Divider';
import Button from 'components/common/Button';
import { SOLO_TERMS, DEFAULT } from './constants';

import ReferralImg from 'assets/referral_side.jpg';

const useStyles = makeStyles((theme) => ({
  img: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  list: {
    'listStyleType': 'none',
    '& li': {
      'position': 'relative',
      'counterIncrement': 'inst',
      'color': theme.palette.text.secondary,
      'marginBottom': theme.spacing(4),
      'display': 'flex',
      'alignItems': 'center',
      '&:before': {
        display: 'flex',
        alignItems: 'center',
        content: 'counter(inst)',
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.light,
        padding: theme.spacing(3),
        fontSize: 14,
        fontWeight: 700,
        textAlign: 'center',
        width: 52,
        height: 52,
        borderRadius: '50%',
        marginRight: theme.spacing(2),
      },
    },
  },
}));

const ReferralHome = ({ onSignup, solo }) => {
  const classes = useStyles();
  const [accepted, setAccepted] = useState(false);
  const profile = useSelector(s => s.student.profile);

  const onCheck = (e) => {
    setAccepted(e.target.checked);
  };

  const TERMS = (profile.product_type === 'solo' || solo) ? SOLO_TERMS : DEFAULT;

  return (
    <Box>
      <Helmet title="Join Referral Program" />
      <Card>
        <Grid container>
          <Grid item sm={7}>
            <Box padding={4} pr={{ xs: 4, sm: 6 }}>
              <Typography paragraph variant="h5">
                WeAdmit’s Friend Referral Program
              </Typography>
              <Typography variant="h1" component={Box} marginBottom={5}>
                {TERMS.onboarding.title}
              </Typography>
              <Typography paragraph color="textSecondary">
                {TERMS.onboarding.description}
              </Typography>
              <Typography paragraph color="textSecondary">
                {TERMS.onboarding.footer}
              </Typography>
              <Box marginBottom={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={accepted}
                      onChange={onCheck}
                      color="primary"
                    />
                  }
                  label={
                    <>
                      I accept referral program{' '}
                      <Link
                        target="_blank"
                        href="https://www.weadmit.com/referral-program"
                      >
                        Terms of Participation
                      </Link>
                    </>
                  }
                  labelPlacement="end"
                />
              </Box>
              <Button
                onClick={onSignup}
                disabled={!accepted}
                color="primary"
                variant="contained"
                size="large"
              >
                Accept Terms of Participation
              </Button>
            </Box>
          </Grid>
          <Grid item sm={5}>
            <img src={ReferralImg} className={classes.img} />
          </Grid>
        </Grid>
        <Box padding={4}>
          <Divider />
        </Box>
        <Box padding={4} pr={{ xs: 4, sm: '20%', lg: '30%' }}>
          <Typography paragraph variant="h5">
            Process
          </Typography>
          <ul className={classes.list}>
            {TERMS.process.map(i => <li>{i}</li>)}
          </ul>
        </Box>
      </Card>
    </Box>
  );
};

export default ReferralHome;
